import React from 'react';
import Policy_banner from '../common_component/policy_banner/Policy_banner';
import Sumbit_btn from '../common_component/common_btn/submit_btn/Sumbit_btn';
import Cancle_btn from '../common_component/common_btn/cancle_btn/Cancle_btn';

function Privacy_Policy() {
    const breadcrumbs = [
        { label: "Home", link: "/", isActive: false },
        { label: "Privacy Policy", link: "", isActive: true },
    ];

    return (
        <>
            <Policy_banner breadcrumbs={breadcrumbs} headingText="Privacy Policy" imgSrc="/assets/images/policy_banner/privacy_policy/privacy_policy_banner.png" />
            <div className="container">
                <div className="content_holder">
                    <div className="text_holder">
                        <p><strong>Effective Date: July 3, 2025</strong></p>
                        <p>
                            Ayansh International Trading FZ-LLC is committed to protecting your privacy.
                            This policy explains how we collect, use, and safeguard your personal information
                            when you visit our website or contact us.
                        </p>
                    </div>
                    <div className="list_holder">
                        <ul>
                            <li>
                                <div className='text_holder'>
                                    <h6>1. Information We Collect</h6>
                                    <p>
                                        When you visit our website or contact us through our forms, we may collect personal information such as
                                        your name, email address, phone number, and any other details you provide voluntarily.
                                        This information helps us understand your needs and respond effectively to your inquiries.
                                    </p>
                                </div>
                            </li>

                            <li>
                                <div className='text_holder'>
                                    <h6>2. How We Use Your Information</h6>
                                    <p>
                                        We use the collected information to communicate with you, respond to your requests,
                                        process inquiries or orders, and improve our website’s functionality and user experience.
                                        Your information may also be used to send you relevant updates or service-related communications.
                                    </p>
                                </div>
                            </li>

                            <li>
                                <div className='text_holder'>
                                    <h6>3. Data Protection</h6>
                                    <p>
                                        We take data security seriously and implement suitable physical, electronic,
                                        and managerial procedures to safeguard your information. These measures help
                                        prevent unauthorized access, maintain data accuracy, and ensure the appropriate
                                        use of your personal data.
                                    </p>
                                </div>
                            </li>

                            <li>
                                <div className='text_holder'>
                                    <h6>4. Sharing of Information</h6>
                                    <p>
                                        We do not sell, rent, or trade your personal information to any third parties.
                                        Your data may be shared only with trusted service providers who assist us in
                                        running our business and providing our services, and only under strict confidentiality obligations.
                                    </p>
                                </div>
                            </li>

                            <li>
                                <div className='text_holder'>
                                    <h6>5. Cookies</h6>
                                    <p>
                                        Our website may use cookies to enhance your browsing experience by remembering your preferences
                                        and enabling certain website features. You may choose to disable cookies through your browser settings;
                                        however, this could affect some functionalities of the website.
                                    </p>
                                </div>
                            </li>

                            <li>
                                <div className='text_holder'>
                                    <h6>6. Third-Party Links</h6>
                                    <p>
                                        Our website may contain links to third-party websites. Please note that we are not responsible
                                        for the privacy practices or content of those external sites. We recommend reviewing their
                                        privacy policies before submitting any personal information.
                                    </p>
                                </div>
                            </li>

                            <li>
                                <div className='text_holder'>
                                    <h6>7. Your Rights</h6>
                                    <p>
                                        You have the right to access, correct, or request the deletion of your personal data held by us.
                                        If you wish to make such a request, or have questions about how we handle your information,
                                        please contact us using the details provided below.
                                    </p>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div className='btn_holder'>
                        <Cancle_btn btnText="Decline" />
                        <Sumbit_btn btnText="Accept" />
                    </div>
                </div>
            </div>
        </>
    );
}

export default Privacy_Policy;
